import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalSessionService } from './msal-session.service';
import { TokenPair } from './token-pair.model';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class OtpSessionService {
  private readonly msalSession = inject(MsalSessionService);
  private readonly tokenStorage = inject(TokenStorageService);
  private readonly router = inject(Router);

  /**
   * Makes a verified OTP login the one active identity in the browser.
   *
   * A cached Azure account left next to the OTP tokens would resurface as the acting identity the
   * moment the OTP session ends, so it is dropped before the OTP tokens are stored. If it cannot
   * be dropped, no OTP session is started at all — returning false rather than leaving two
   * identities side by side.
   */
  async start(tokens: TokenPair): Promise<boolean> {
    try {
      await this.msalSession.clear();
    } catch (error) {
      // The inline message tells the user what to do; only the console carries the cause, which is
      // the sole diagnostic left once this happens on someone else's machine.
      console.warn('OtpSessionService: could not drop the cached Azure identity, OTP login aborted', error);
      return false;
    }
    this.tokenStorage.setTokens(tokens);
    // The session exists from here on, so a failed redirect must not be reported as a failed
    // login — but it must not reject either, or the caller never leaves its submitting state.
    await this.router
      .navigate(['/'])
      .catch((error: unknown) => console.warn('OtpSessionService: redirect to the start page failed', error));
    return true;
  }
}
